import { Path } from "components/app.component";
import React from "react";
import { Breadcrumbs, IconButton, Icon, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import "./breadcrumb.css";
import { useSelector } from "react-redux";
import { GlobalState, Rental, setNavigation, store } from "store/rentals-store";

export default function StepsBreadcrumb() {
  const rental: Rental = useSelector((state: GlobalState) => state.rental);

  function onClick(path: Path) {
    store.dispatch(setNavigation(path));
  }

  return (
    <Breadcrumbs
      className="breadcrumb"
      aria-label="breadcrumb"
      separator={<Icon>arrow_forward</Icon>}
    >
      <Link to={Path.Home} onClick={() => onClick(Path.Home)}>
        <Tooltip title="Agendar">
          <span>
            <IconButton
              aria-label="schedule"
              color="primary"
              data-testid="schedule-btn"
            >
              <Icon fontSize="large">edit_calendar</Icon>
            </IconButton>
          </span>
        </Tooltip>
      </Link>
      <Link
        to={Path.Contact}
        onClick={() => onClick(Path.Contact)}
        color={"inherit"}
      >
        <Tooltip title="Información de contacto">
          <span>
            <IconButton
              aria-label="contact"
              disabled={!(rental.totals?.items.length > 0)}
              color="primary"
              data-testid="contact-btn"
            >
              <Icon fontSize="large">contact_emergency</Icon>
            </IconButton>
          </span>
        </Tooltip>
      </Link>
      <Link
        to={Path.Delivery}
        onClick={() => onClick(Path.Delivery)}
        color={"inherit"}
      >
        <Tooltip title="Lugar de entrega">
          <span>
            <IconButton
              aria-label="location"
              disabled={!rental.contactInfo?.email}
              color="primary"
              data-testid="location-btn"
            >
              <Icon fontSize="large">edit_location</Icon>
            </IconButton>
          </span>
        </Tooltip>
      </Link>
      <Link
        to={Path.Payment}
        onClick={() => onClick(Path.Payment)}
        color={"inherit"}
      >
        <Tooltip title="Método de pago">
          <span>
            <IconButton
              aria-label="payment"
              disabled={!rental.delivery?.deliveryPointId}
              color="primary"
              data-testid="payment-btn"
            >
              <Icon fontSize="large">credit_card</Icon>
            </IconButton>
          </span>
        </Tooltip>
      </Link>
    </Breadcrumbs>
  );
}
